export default class ConfigurationSet {
    public id: string = '';
    public isDefault: boolean = false;
    public name: string | undefined;

    public constructor(partial?: Partial<ConfigurationSet>) {
        Object.assign(this, partial);
    }
}